/**
 * Fixed identity used when the app runs in demo mode (no Supabase auth).
 *
 * We use a UUID (not a plain string like "demo-coach") so it can slot into
 * both UUID-typed columns (teams.coach_id, coach_conversations.coach_id,
 * brain_memories.coach_id, etc.) *and* TEXT columns (video_calibrations,
 * video_capture_sessions) without two parallel code paths.
 *
 * Value is intentionally recognisable in DB dumps: `...dec0...` hex chunks.
 */
export const DEMO_COACH_ID = '00000000-dec0-dec0-dec0-000000000000';
